import React, { useEffect, useState, useRef } from "react";
import "./ideaCortaTod.css";
import "../../../components/modal/modal.css";

import { useCounter } from "../../../hooks/useCounter";
import Modal2 from "../../../components/modal/Modal";
import { useAxios2 } from "../../../hooks/useAxios";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ModalVideo from "../../../components/modal/ModalVideo";
import { useNavigate } from 'react-router-dom';

function obtenerRuta(rutavideo) {
  var partes = rutavideo.split("src=");

  return partes[1];
}

const IdeaCortaTod = ({ dataideas, totale = 0, limite = 8 }) => {
  const { counter, increment, decrement, resetCounter, defaultValue } =
    useCounter(0);
  const [ficha, setFicha] = useState(8);
  const [t, i18n] = useTranslation("ideaCorta");
  const navigate = useNavigate();

  //cuantos registros trae
  const [numer, setNumer] = useState(`ideas/count/by-lang/es`);

  // const { data, isLoading, error } = useAxios(url);
  const [ide, setIde] = useState([]);

  useEffect(() => {
    if (dataideas) {
      setIde(dataideas);
    }
  }, [dataideas]);

  const { dataS, isLoadingS } = useAxios2(
    `ideas/gnideas?offset=0&next=1000&lang=${i18n.language}`
  );
  const location = useLocation();

  useEffect(() => {
    if (dataS) {
      dataS.map((element, index) => {
        if (location.pathname.includes(element.preview)) {
          if (
            element.tipo === "texto-imagen" ||
            element.tipo === "texto-video" ||
            element.tipo === "video" ||
            element.tipo === "imagen"
          ) {
            openModal2(element.contenido, "", element.preview, element.id);
          }
          if (element.tipo === "carrete") {
            openModal2(element.contenido, "carrete", element.preview, element.id);
          }
        }
      });
    }
  }, [dataS]);

  const verYoutu = (ruta) => {
    console.log("la ruta que se va a tratar de abri es----->" + ruta);

    // <a href={ruta} target="_blank"> ejemplo de la ruta que estoy recibiendo </a>

    window.open(ruta, "_blank");
    // <a href="https://www.ejemplo.com"> Visita nuestro sitio web </a>
  };
  const clase = (index) => {
    if (index === 0 || index < 3 || index > 4) {
      return "card";
    } else if (index === 3 || index === 4) {
      return " card card2";
    }
  };

  const renderizarMensaje = (tipo, contenido, preview, index, id, titulo) => {
    if (index === 0 || index < 3 || index > 4) {
      if (tipo === "texto") {
        return (
          <div className="text1">
            {/* <p>TEXTO</p> */}
            <div
              className="mensageDiv"
              dangerouslySetInnerHTML={{ __html: contenido }}
            ></div>
          </div>
        );
      } else if (tipo === "imagen") {
        return (
          <div className="card-type-img">
            {/* <p>IMAGEN</p> */}
            <img
              className="img1"
              src={"https://www.ricardosalinas.com" + preview}
              alt="Imagen ideas"
            />
          </div>
        );
      } else if (tipo === "texto-video") {
        return (
          <div className="imageTxtContainer">
            {/* <p>TEXTO-VIDEO</p> */}
            <div
              className="playImageContainerMobile"
              onClick={() => openModal2(contenido, "", preview, id)}
            >
              <div className="arrow-right" />
            </div>
            <button onClick={() => openModal2(contenido, "", preview, id)}>
              {/* <img className="img1 img_text_vid_grand " src={'https://www.ricardosalinas.com' + preview} alt="Imagen ideas" /> */}
              <img
                className="img1 img_text_vide "
                src={"https://www.ricardosalinas.com" + preview}
                alt="Imagen ideas"
              />
            </button>
            <div
              className="cinta"
              onClick={() => openModal2(contenido, "", preview, id)}
            >
              <p className="tit_LB">{titulo}</p>
            </div>
          </div>
        );
      } else if (tipo === "texto-imagen") {
        // return <div>
        return (
          <>
            {/* <p>TEXTO-IMAGEN</p> */}
            <button onClick={() => openModal2(contenido, "", preview, id)}>
              <img
                className="img1 img_text"
                src={"https://www.ricardosalinas.com" + preview}
                alt="Imagen ideas"
              />
            </button>
            <div
              className="cinta"
              onClick={() => openModal2(contenido, "", preview, id)}
            >
              <p className="tit_LB">Ver idea</p>
            </div>
            {/* </div> */}
          </>
        );
      } else if (tipo === "carrete") {
        return (
          <div>
            {/* <p>CARRETE</p> */}
            <button
              className="boton_Lin2"
              onClick={() => openModal2(contenido, "carrete", preview, id)}
            >
              <img
                className="img_carrete "
                src={"https://www.ricardosalinas.com" + preview}
                alt="Imagen ideas"
              />
            </button>
            <div
              className="cinta"
              onClick={() => openModal2(contenido, "carrete", preview, id)}
            >
              <p className="tit_LB">{titulo}</p>
            </div>
          </div>
        );
      } else if (tipo === "youtube") {
        return (
          <div className="div-youtube-list">
            {/* <p>YOUTUBE</p> */}
            <div className="imageTxtContainer">
              <div
                className="playImageContainerMobile"
                onClick={() => openModalVideo(contenido, id)}
              >
                <div className="arrow-right" />
              </div>
              <button onClick={() => openModalVideo(contenido, id)}>
                {/* <img className="img1 img_text_vid_grand " src={'https://www.ricardosalinas.com' + preview} alt="Imagen ideas" /> */}
                <img
                  className="img1 img_text_vide "
                  src={"https://www.ricardosalinas.com" + preview}
                  alt="Imagen ideas"
                />
              </button>
              <div
              className="cinta"
              onClick={() => openModalVideo(contenido, id)}
            >
              <p className="tit_LB">{titulo}</p>
            </div>
            </div>
          </div>
        );
      } else if (tipo === "video") {
        return (
          <div className="div-youtube-list">
            {/* <p>VIDEO</p> */}
            {/* <button onClick={() => openModal2(contenido, '')}>  esta es la linea originall que tenia*/}
            <div className="imageTxtContainer">
            <div
                className="playImageContainerMobile"
                onClick={() => openModal2("https://www.ricardosalinas.com"+contenido, "video", preview, id)}
              >
                <div className="arrow-right" />
              </div>
            <button onClick={() => openModal2("https://www.ricardosalinas.com"+contenido, "video", preview, id)}>
              <img
                className="img1 img_text"
                src={"https://www.ricardosalinas.com" + preview}
                alt="Imagen ideas"
              />
            </button>
            <div
              className="cinta"
              onClick={() => openModal2("https://www.ricardosalinas.com"+contenido, "video", preview, id)}
            >
              <p className="tit_LB">{titulo}</p>
            </div>
            </div>
          </div>
        );
      } else {
        return <p>La condición es falsa que tipo eres-----: {tipo}</p>;
      }
    } else if (index === 3 || index === 4) {
      if (tipo === "texto") {
        return (
          <div className="div_mayor">
            {/* <p>TEXTO-2</p> */}
            <div className="text1">
              <div
                className="mensageDiv"
                dangerouslySetInnerHTML={{ __html: contenido }}
              />
            </div>
          </div>
        );
      } else if (tipo === "imagen") {
        return (
          <div className="div_mayor card-type-img">
            {/* <p>IMAGEN-2</p> */}
            <img
              className="img1"
              src={"https://www.ricardosalinas.com" + preview}
              alt="Imagen ideas"
            />
          </div>
        );
      } else if (tipo === "texto-imagen") {
        return (
          <div className="div_mayor">
            {/* <p>TEXTO-IMAGEN-2</p> */}
            <button
              className="boton_Lin2"
              onClick={() => openModal2(contenido, "", preview, id)}
            >
              <img
                className="img1 img_text"
                src={"https://www.ricardosalinas.com" + preview}
                alt="Imagen ideas"
              />
            </button>
            <div
              className="cinta"
              onClick={() => openModal2(contenido, "", preview, id)}
            >
              <p className="tit_LB">Leer blog</p>
            </div>
          </div>
        );
      } else if (tipo === "texto-video") {
        return (
          <div className="div_mayor">
            {/* <p>TEXTO-VIDEO-2</p> */}
            <button
              className="boton_Lin2"
              onClick={() => openModal2(contenido, "", preview, id)}
            >
              <div className="playImageContainer">
                <div className="arrow-right" />
              </div>
              <img
                className="img1 img_text_vid_grand "
                src={"https://www.ricardosalinas.com" + preview}
                alt="Imagen ideas"
              />
            </button>
            <div
              className="cinta"
              onClick={() => openModal2(contenido, "", preview, id)}
            >
              <p className="tit_LB">{titulo}</p>
            </div>
          </div>
        );
      } else if (tipo === "carrete") {
        return (
          <div>
            {/* <p>CARRETE-2</p> */}
            <button
              className="boton_Lin2"
              onClick={() => openModal2(contenido, "carrete", preview, id)}
            >
              <img
                className="img_carrete "
                src={"https://www.ricardosalinas.com" + preview}
                alt="Imagen ideas"
              />
            </button>
            <div
              className="cinta"
              onClick={() => openModal2(contenido, "carrete", preview, id)}
            >
              <p className="tit_LB">Ver galería</p>
            </div>
          </div>
        );
      } else if (tipo === "youtube") {
        return (
          <div className="div-youtube-list">
            {/* <p>YOUTUBE-2</p> */}
            {/* <button onClick={() => openModal2(contenido, '')}> */}
            <div className="imageTxtContainer">
              <div
                className="playImageContainerMobile"
                onClick={() => openModalVideo(contenido, id)}
              >
                <div className="arrow-right" />
              </div>
              <button onClick={() => openModalVideo(contenido,id)}>
                {/* <img className="img1 img_text_vid_grand " src={'https://www.ricardosalinas.com' + preview} alt="Imagen ideas" /> */}
                <img
                  className="img1 img_text_vide "
                  src={"https://www.ricardosalinas.com" + preview}
                  alt="Imagen ideas"
                />
              </button>
              <div
              className="cinta"
              onClick={() => openModalVideo(contenido,id)}
            >
              <p className="tit_LB">{titulo}</p>
              </div>
            </div>
          </div>
        );
      } else if (tipo === "video") {
        return (
          <div className="div-youtube-list">
            {/* <p>VIDEO-2</p> */}
            <div className="imageTxtContainer">
            <div
                className="playImageContainerMobile"
                onClick={() => openModal2("https://www.ricardosalinas.com"+contenido, "video", preview, id)}
              >
                <div className="arrow-right" />
            </div>

            <button onClick={() => openModal2("https://www.ricardosalinas.com"+contenido, "video", preview, id)}>
              <img
                className="img1 img_text"
                src={"https://www.ricardosalinas.com" + preview}
                alt="Imagen ideas"
              />
            </button>
            <div
              className="cinta"
              onClick={() => openModal2("https://www.ricardosalinas.com"+contenido, "video", preview, id)}
            >
              <p className="tit_LB">{titulo}</p>
              </div>
            </div>
          </div>
        );
      } else {
        return (
          <div class="div_mayor">
            {" "}
            <p> que tipo eres-----: {tipo}</p>;
          </div>
        );
      }
    }
  };

  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const [id_liga, setId_liga] = useState("");
  const [variable1, setVariable1] = useState("");
  const [variable2, setVariable2] = useState("");

  const [isOpenModalVideo, setIsOpenModalVideo] = useState(false);
  const [urlVideo, setUrlVideo] = useState("");

  const openModal2 = (value1, value2, value3, value4) => {
    setVariable1(value1);
    setVariable2(value2);
    setId_liga(value4);
    setIsModalOpen2(true);
    navigate(`/${i18n.language}/Ideas-en-Corto?idea=${value4}`);
  };

  const closeModal2 = () => {
    setVariable1("");
    setVariable2("");
    setIsModalOpen2(false);
  };

  const openModalVideo = (contenido, value4) => {
    setUrlVideo(contenido);
    setIsOpenModalVideo(true);
    navigate(`/${i18n.language}/Ideas-en-Corto?idea=${value4}`);
  };

  const closeModalVideo = () => {
    setUrlVideo("");
    setIsOpenModalVideo(false);
  };

  return (
    <>
      <div class="row2_LB">
        <div class="list_content--items">
          {ide.slice(totale, limite).map((item, index) => (
            <div class={clase(index)} key={index}>
              <div className="div-card-1">
                {renderizarMensaje(
                  item.tipo,
                  item.contenido,
                  item.preview,
                  index,
                  item.id,
                  item.titulo,
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      <Modal2
        isOpen={isModalOpen2}
        closeModal={closeModal2}
        variable1={variable1}
        variable2={variable2}
        id_idea={id_liga}
      />

      <ModalVideo
        isOpen={isOpenModalVideo}
        closeModal={closeModalVideo}
        urlVideo={urlVideo}
      />
    </>
  );
};
export default IdeaCortaTod;
